import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import s from './index.module.scss';

import { PaymentOffer } from './paymentOffer';
import PaymentModalV5 from '../../components/common/paymentModalV5';
import { MainScreen } from '../../components/everydoggyV10/mainScreen';
import { MainScreenK9 } from '../../components/everydoggyV10/mainScreenK9';
import { Timer } from '../../components/everydoggyV2/timerV2';
import DogBehaviorProgramCard from '../../components/everydoggyV5/dogBehaviorProgramCard';
import TrainingProfile from '../../components/everydoggyV10/trainingProfile';
import TrainingProfileK9 from '../../components/everydoggyV10/trainingProfileK9';
import { Benefits } from '../../components/everydoggyV5/benefits/benefits';
import { PolycyBlockV2 } from '../../components/everydoggyV2/polycyBlockV2';
import { GetMyPlanBlock } from '../../components/everydoggyV5/getMyPlanBlock/getMyPlanBlock';
import { setPaymentProduct } from '../../reduxStore/data/actions';
import { getPricesConfig } from '../getPricesConfig';
import { SupportBlock } from '../../components/everydoggyV2/supportBlock/supportBlock';
import { ReviewsSlider } from '../../components/everydoggyV10/reviewsSlider';
import { Footer } from '../../components/everydoggyV2/footer/footer';
import { trackBlockScrollDepth } from '../../utils/scripts/scrollTracker';
import { getParameterFromURL } from '../../utils/scripts';
import { getPaymentCurrency } from '../../utils/scripts/currency';
import {
  clearPaypalRestoreProductId,
  getPaypalRestoreProductId,
} from '../../utils/payments/paypalRestoreProduct';
import { RootState, useAppDispatch } from '../../store';

import { MoneyBack } from '../../components/everydoggyV5/moneyBack/moneyBack';
import { Faq } from '../../components/everydoggyV5/faq/index';
import StickyGetMyPlan from '../../components/everydoggyV10/stickyGetMyPlan';

/** Discount tariffs that get the special-offer scroll tracking on this paywall. */
const SPECIAL_OFFER_TARIFFS = ['v42'];

function EverydoggyV10() {
  const dispatch = useAppDispatch();
  const product = useSelector((state: RootState) => state.data.paymentModal.product);
  const tariff = useSelector((state: RootState) => state.data.tariff);
  const k9Funnel = useSelector((state: RootState) => state.data.k9Funnel);

  const paypalRestoreProductId = getPaypalRestoreProductId();
  const hasPaypalRedirectProduct = Boolean(getParameterFromURL('paypal_product_id') || paypalRestoreProductId);
  const currency = getPaymentCurrency();

  // NOTE: unlike V5 (usePaymentProductSync + tariffPaymentConfig), this paywall
  // ships its own hardcoded default products for v41/v42/v47 — kept as-is.
  useEffect(() => {
    trackBlockScrollDepth(s.firstScreenWrapper, 'paywall');

    if (!product.name && !hasPaypalRedirectProduct) {
      let defaultProductId;
      let oldPrice;
      let productName;

      if (tariff === 'v41') {
        defaultProductId = getPricesConfig(tariff).everydoggyNewDesign.secondPriceConfig.id;
        oldPrice = '62.82';
        productName = `${currency}6.99 per 1m intro, then ${currency}29.99 per 2 weeks`;
      } else if (tariff === 'v47') {
        const pricesConfig = getPricesConfig(tariff).everydoggyNewDesign;
        defaultProductId = pricesConfig.firstPriceConfig.id;
        oldPrice = pricesConfig.firstPriceConfig.defaultOldPrices;
        productName = pricesConfig.firstPriceConfig.productName;
      }

      if (!defaultProductId) return;

      const defaultProduct = {
        product: defaultProductId.toString(),
        oldPrice,
        name: productName,
      };
      dispatch(setPaymentProduct(JSON.stringify(defaultProduct)));
    }
    document.querySelector('body').style.overflowX = 'visible';
    (document.querySelector('.app') as HTMLElement).style.overflow = 'visible';
  }, []);

  useEffect(() => {
    if (hasPaypalRedirectProduct) {
      return;
    }

    if (tariff === 'v42') {
      const productName = `${currency}3.99 per 1m intro, then ${currency}29.99 per 2 weeks`;
      const defaultProductId = getPricesConfig(tariff).everydoggyNewDesign.secondPriceConfig.id;
      const oldPrice = '62.82';

      const discountProduct = {
        product: defaultProductId.toString(),
        oldPrice,
        name: productName,
      };
      dispatch(setPaymentProduct(JSON.stringify(discountProduct)));
    }

    if (SPECIAL_OFFER_TARIFFS.includes(tariff)) {
      trackBlockScrollDepth(s.firstScreenWrapperV2, 'special_offer');
    }
  }, [tariff]);

  useEffect(() => {
    if (!paypalRestoreProductId || !product?.name) {
      return;
    }

    if (String(product.name) === paypalRestoreProductId) {
      clearPaypalRestoreProductId();
    }
  }, [paypalRestoreProductId, product?.name]);

  return (
    <>
      <div className={s.firstScreenWrapper}>
        <div key="paywall-timer" className={s.timerWrapper}>
          <Timer />
        </div>
        {k9Funnel ? (
          <MainScreenK9 key="paywall-main-screen" />
        ) : (
          <MainScreen key="paywall-main-screen" />
        )}
        <div className={s.barChartWrapper}>
          <DogBehaviorProgramCard />
        </div>
        <div className={s.trainingProfileWrapper}>
          {k9Funnel ? <TrainingProfileK9 /> : <TrainingProfile />}
        </div>
        <div className={s.offerWrapper} data-offer-wrapper>
          <PaymentOffer currentProduct={product.name} discount={false} tariff={tariff} />
        </div>
        <div className={s.polycyWrapper}>
          <PolycyBlockV2 />
        </div>
        <div className={s.getMyplanWrapper}>
          <GetMyPlanBlock tariff={tariff} />
        </div>
        <div className={s.benefitsWrapper}>
          <Benefits />
        </div>
        <div className={s.ReviewsSliderWrapper}>
          <ReviewsSlider />
        </div>
        <div className={s.offerWrapper} data-offer-wrapper>
          <PaymentOffer currentProduct={product.name} discount={false} tariff={tariff} />
        </div>
        <div className={s.polycyWrapper}>
          <PolycyBlockV2 />
        </div>
        <div className={s.getMyplanWrapper}>
          <GetMyPlanBlock tariff={tariff} />
        </div>
        <div className={s.moneyBackWrapper}>
          <MoneyBack />
        </div>
        <Faq />

        <div className={s.supportBlockWrapper}>
          <SupportBlock />
        </div>
        <Footer />
      </div>
      <PaymentModalV5 label={null} />
      <StickyGetMyPlan />
    </>
  );
}

export default EverydoggyV10;
